export default {"src":"/_next/static/media/icon-down.d74c2028.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};